// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React, { Dispatch, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Heading } from '@lili/lili-frontend-common';
import { twMerge } from 'tailwind-merge';
import { PROFIT_AND_LOSS_STYLES } from '../constants';
import Button from '../../../generic-components/Button';
import Icon from '../../../generic-components/Icon';
import { DownArrow } from '../../../assets/svg';
import { IProfitAndLossFilters, IProfitAndLossPeriod, ProfitAndLossPeriodType } from '../constants/types';
import { datesArr, isUserExistInPrevYear } from '../helpers';
import { useStore } from '../../../store';
import { ReactComponent as Checkmark } from '../../../assets/icons/svg/shared/ic-shared-checkmark.svg';
import { ReactComponent as RightArrow } from '../../../assets/icons/svg/shared/ic-shared-right-arrow.svg';
import { VIEWS_MAP } from '../../../router/constants';

interface IProps {
  selectedPeriod: IProfitAndLossPeriod;
  showPeriodOption: boolean;
  setShowPeriodOption: Dispatch<React.SetStateAction<any>>;
  handleToggleDropdown: (filterType: string) => void;
  filterObject: IProfitAndLossFilters;
  handleSelectPeriodType: (type: ProfitAndLossPeriodType) => void;
}

export const PeriodTypeFilter = ({
  selectedPeriod,
  showPeriodOption,
  handleToggleDropdown,
  filterObject,
  handleSelectPeriodType,
  setShowPeriodOption,
}: IProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  const periodTypeRef = useRef<HTMLDivElement>(null);

  const {
    customer: { createTime },
  } = useStore((state) => state.summary);

  const handleClickOutside = (event: Event) => {
    if (periodTypeRef.current && !periodTypeRef.current.contains(event.target as Node)) {
      setShowPeriodOption(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  });
  const perdiodTypes = datesArr.filter(
    (period) => !(period.type === ProfitAndLossPeriodType.ALL_TIME && location.pathname === `/${VIEWS_MAP.EXPENSES}`),
  );
  return (
    <div className={showPeriodOption ? PROFIT_AND_LOSS_STYLES.PERIOD_OUTLINE : ''}>
      <div className={PROFIT_AND_LOSS_STYLES.PERIOD_TYPE_WRAPPER} ref={periodTypeRef}>
        <button
          id='periodType'
          type='button'
          className='flex items-center   px-[12px]  py-[6px] min-w-[204px] min-h-[36px]  rounded-l-[8px]  justify-between duration-200 pointer hover:bg-bw02'
          onClick={() => handleToggleDropdown('periodType')}
        >
          <div className='flex items-center justify-between w-full'>
            <Heading.H10 id={selectedPeriod.type} className=''>
              {selectedPeriod.title}
            </Heading.H10>
            <Icon className='mr-[2px]' src={DownArrow} rotated={showPeriodOption} />
          </div>
        </button>
        {showPeriodOption && (
          <div className={PROFIT_AND_LOSS_STYLES.PERIOD_OPTION_WRAPPER}>
            {perdiodTypes.map((item, index) => (
              <div
                key={item.type}
                className={
                  index === perdiodTypes.length - 1
                    ? PROFIT_AND_LOSS_STYLES.SUB_WRAPPER_LAST
                    : PROFIT_AND_LOSS_STYLES.SUB_BUTTON_WRAPPER
                }
              >
                <Button
                  id={`periodTypeOption_${item.type}`}
                  title={t(item.title)}
                  childElement={
                    filterObject.period?.periodType === item.type ? (
                      <Checkmark className='mr-[2px] text-action03' />
                    ) : (
                      item.isCustom && <RightArrow className='mr-[2px] mt-[3px] h-[16px] w-[16px] text-bw07' />
                    )
                  }
                  className={twMerge(
                    PROFIT_AND_LOSS_STYLES.PERIOD_TYPE_SUB_BUTTON,
                    index === 0 && PROFIT_AND_LOSS_STYLES.FIRST_PERIOD_BUTTON,
                    index === perdiodTypes.length - 1 && PROFIT_AND_LOSS_STYLES.PERIOD_TYPE_SUB_BUTTON_LAST,
                    filterObject.period?.periodType === item.type &&
                      PROFIT_AND_LOSS_STYLES.PERIOD_TYPE_SUB_BUTTON_ACTIVE,
                    item.type === ProfitAndLossPeriodType.LAST_YEAR &&
                      !isUserExistInPrevYear(createTime) &&
                      PROFIT_AND_LOSS_STYLES.PERIOD_TYPE_DISABLED_BUTTON,
                  )}
                  onClick={() => handleSelectPeriodType(item.type)}
                  disable={item.type === ProfitAndLossPeriodType.LAST_YEAR && !isUserExistInPrevYear(createTime)}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
